import { Directive, HostBinding } from '@angular/core';

@Directive({
    selector: 'mir-popup-header, [mir-popup-header], [mirPopupHeader], popup-header, [popup-header], [popupHeader]',
    standalone: false
})
export class PopupHeaderDirective {

  @HostBinding('class') hostCssClasses = 'mir-popup-header popup-header';

}
